import classNames from 'classnames';
import React from 'react';

/**
 * ShowBlogHeroHeadline component renders the headline section for show blog hero
 * @param {object} props - Component props
 * @param {React.ReactNode} props.children - The headline text content
 * @param {string} props.className - CSS classes for the headline
 * @param {React.ReactNode} [props.timestamp] - Optional timestamp element
 * @param {React.ReactNode} [props.dek] - Optional deck/subtitle element
 * @returns {React.Element} Rendered headline section
 */
const ShowBlogHeroHeadline = ({
  children,
  className,
  timestamp = null,
  dek = null,
}) => {
  const HeadlineTagName = 'h1';
  const block = 'showblog-hero-headline';

  return (
    <div
      className={classNames(
        block,
      )}
    >
      <HeadlineTagName
        className={classNames(
          className,
          'publico-hed lh-title',
        )}
        data-test="showBlog-hero__headline"
        data-testid="showBlog-hero__headline"
      >
        {children}
      </HeadlineTagName>
      <div>{dek}</div>
      {timestamp}
    </div>
  );
};

export { ShowBlogHeroHeadline };
